import instanceAxios from "./intanceAxios";

export const AuthenticationService = {
    loginWithMicrosoft: async (data) => await instanceAxios.post('/authentication/login-microsoft/', data),
    loginEmail: async (data) => await instanceAxios.post('/authentication/login-email/', data),
    logout: async (data) => await instanceAxios.post('/authentication/logout/', data),

    //Roles
    createRole: async (data) => await instanceAxios.post('/authentication/role/', data),
    getRoles: async (params) => await instanceAxios.get('/authentication/role/', { params }),
    updateRole: async (data) => await instanceAxios.put('/authentication/role/', data),
    getByHashCode: async (hash_code) => await instanceAxios.get(`/authentication/role/${hash_code}/`),
    deleteRole: async (hash_code) => await instanceAxios.delete(`/authentication/role/`, { data: { hash_code } }),

    //Permisos
    getPermissions: async (params) => await instanceAxios.get('/authentication/permission/', { params }),
    createPermission: async (data) => await instanceAxios.post('/authentication/permission/', data),
    updatePermission: async (data) => await instanceAxios.put('/authentication/permission/', data),
    deletePermission: async (id) => await instanceAxios.delete(`/authentication/permission/`, { data: { id } }),


    //Secciones
    getSections: async (params) => await instanceAxios.get('/authentication/section/', { params }),

}